import './Services.css';
import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useTranslation } from 'react-i18next';

gsap.registerPlugin(ScrollTrigger);

function Services() {
  const { t } = useTranslation();
  const sectionRef = useRef(null);
  const cardsRef = useRef([]);

  const services = [
    {
      title: t('services.service1.title'),
      desc: t('services.service1.desc')
    },
    {
      title: t('services.service2.title'),
      desc: t('services.service2.desc')
    },
    {
      title: t('services.service3.title'),
      desc: t('services.service3.desc')
    },
    {
      title: t('services.service4.title'),
      desc: t('services.service4.desc')
    },
    {
      title: t('services.service5.title'),
      desc: t('services.service5.desc')
    },
    {
      title: t('services.service6.title'),
      desc: t('services.service6.desc')
    },
    {
      title: t('services.service7.title'),
      desc: t('services.service7.desc')
    },
    {
      title: t('services.service8.title'),
      desc: t('services.service8.desc')
    },
    {
      title: t('services.service9.title'),
      desc: t('services.service9.desc')
    },
    {
      title: t('services.service10.title'),
      desc: t('services.service10.desc')
    }
  ];

  useEffect(() => {
    const cards = cardsRef.current;
    gsap.set(cards, { opacity: 0, y: 60 });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: sectionRef.current,
        start: 'top 80%',
        end: 'bottom 20%',
        scrub: 1,
        toggleActions: 'play none none reverse',
      }
    });

    cards.forEach((card, i) => {
      tl.to(card, {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: 'power2.out',
      }, i * 0.18);
    });

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, [t]);

  return (
    <section 
      className="services-timeline-section" 
      id="services" 
      ref={sectionRef}
      style={{
        background: `linear-gradient(rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), url(${process.env.PUBLIC_URL}/images/accounting-bg.webp)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed'
      }}
    >
      <h2 style={{
        textAlign:'center', 
        marginBottom:32,
        fontSize: '2.2rem',
        fontWeight: 600,
        letterSpacing: '1px',
        background: 'linear-gradient(90deg, #1D4053 0%, #3498db 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        textFillColor: 'transparent'
      }}>{t('services.title')}</h2>
      <div className="services-timeline-wrap">
        <div className="services-timeline-line"></div>
        <div className="services-timeline-grid">
          {services.map((service, i) => (
            <div
              className={`services-timeline-card ${i%2===0 ? 'left' : 'right'}`}
              key={i}
              ref={el => cardsRef.current[i] = el}
            >
              <div className="services-timeline-content">
                <div className="services-timeline-title">{service.title}</div>
                <div className="services-timeline-desc">{service.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services; 